import React, { useEffect } from "react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { useMachine } from "@xstate/react";
import { createMachine } from "xstate";

import { actions } from "./actions";
import { MACHINE_CONFIG } from "./config";
import { services } from "./services";

export const switchRolesContext = React.createContext({});
export let switchRolesMachine: any;

const MODULE_NAME = "machines.switchRoles";
const log: any = LoggerModule?.getInstance();

export const useSMSwitchRoles = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  switchRolesMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(switchRolesMachine);

  return {
    switchRolesMachine: switchRolesMachine,
    switchRolesState: state,
    switchRolesSend: send,
  };
};
